export {};

/*
 * По ховеру по ссылке в гор. меню начиная с ширины 1440 открывается выпдающее меню.
 * При этом скрытие его происходит при наведении на другую ссылку этого меню, либо при уходе указателя
 * с выпадающего меню в любое место кроме ссылки, вызвавшей его появление.
 *
 * todo: убирании указателя с ссылки в любое место кроме выпавшего меню или других ссылок этого меню - скрыть меню
 */

const active = 'active';
const $html = $(document.documentElement);
const $menu = $('.menu');
const $blurNotMenu = $menu.hasClass('menu--v2');
const $notMenu = $('body > .wrap > div:not(header)');
const $header = $('header.head.head-menuv2')
const $menuNavItems = $('.menu-nav__item');
const $nav = $('.nav');
const $menuInners = $('.menu__inner');
const $menuRightInners = $('.menu__inner-right');
const $navLinks = $('.nav__link');
const $btnCloseMenu = $('.js-btn-close-menu');

const $menuRightInnersDefaultActive = $menuRightInners.filter('.active');

let isOpen = false;

let linkMouseLeaveTimeoutBeforeClose;

$btnCloseMenu.on('click', () => {
    closeMenu();
});

$nav.on('mouseleave', function onMouseLeave() {
    if (innerWidth >= NLMK.mediaQueries.horizontalTablet.min) {
        linkMouseLeaveTimeoutBeforeClose = setTimeout(closeMenu, 10);
    }
});

$menu.on('mouseenter', function onMenuInnerMouseEnter() {
    if (linkMouseLeaveTimeoutBeforeClose) {
        clearTimeout(linkMouseLeaveTimeoutBeforeClose);
    }
});

$(document)
    .on('touchstart', function onTouchEnd(evt) {
        if (isOpen) {
            const isTargetOutsideMenu = !$menu.find(evt.target).length;
            const isTargetOutsideNav = !$nav.find(evt.target).length;

            if (isTargetOutsideMenu && isTargetOutsideNav) {
                closeMenu();
            }
        }
    })
    .on('touchend', '.nav__link', function onTouchEnd(evt) {
        const $link = $(this);

        const activationTime = $link.data('activation-time');
        const isLongTimeAfterTouchStart = activationTime ? new Date().getTime() - activationTime > 300 : false;

        const usePreventDefault = !$link.hasClass('active') || isLongTimeAfterTouchStart;

        if (usePreventDefault) {
            evt.preventDefault();
        }
    })
    .on(NLMK.MOUSEENTER_EVENT, '.nav__link', function onMouseEnter() {
        const isEnabled = NLMK.isHorizontalTabletWidth() || NLMK.isDesktopWidth();

        if (isEnabled) {
            const Link = this;

            onHoverHorizontalNavLink(Link);
        }
    })
    .on('touchend', '.menu-nav__link', function onTouchEnd(evt) {
        const $link = $(this);
        const $parent = $link.parent();

        const activationTime = $parent.data('activation-time');
        const isLongTimeAfterTouchStart = activationTime ? new Date().getTime() - activationTime > 300 : false;

        const usePreventDefault = !$parent.hasClass('active') || isLongTimeAfterTouchStart;

        if (usePreventDefault) {
            evt.preventDefault();
        }
    })
    .on(NLMK.MOUSEENTER_EVENT, '.menu-nav__link', function onMouseEnter() {
        const $link = $(this);
        const $linkParent = $link.parent();
        const menuInnerRightSelector = $link.data('inner-right-selector');
        const $menuInnerRight = $(menuInnerRightSelector);

        $('.menu__children-block').find('.menu__inner-right.active').removeClass(active);
        $linkParent.siblings().removeClass(active);

        if ($menuInnerRight.length) {
            const theme = $link.data('theme');

            $menu.toggleClass('light', 'light' === theme);

            $menuInnerRight
                .addClass(active)
                .siblings()
                .removeClass(active);

            $linkParent
                .addClass(active)
                .data('activation-time', new Date().getTime());
        }
    });

/**
 * Срабатывает по наведению на ссылку в основном горизонтальном меню
 *
 * @param {HTMLAnchorElement} Link
 */
function onHoverHorizontalNavLink(Link) {
    const $navLink = $(Link);
    const menuId = $navLink.data('menu-id');

    const $menuInner = $('#menu-id-' + menuId);

    $navLinks.not($navLink).removeClass(active);

    if ($menuInner.length) {
        $navLink.addClass(active).data('activation-time', new Date().getTime());

        const theme = $navLink.data('theme');
        $menu.toggleClass('light', 'light' === theme);

        $navLinks.not($navLink).removeClass(active);

        const onMenuInnerMouseLeave = (evt) => {
            const $target = $(evt.target);
            const isCurrentNavLink = $target.is($navLink);

            if (!isCurrentNavLink) {
                closeMenu();
            }
        };

        $menuInner
            .on('mouseleave', onMenuInnerMouseLeave)
            .addClass(active)
            .siblings()
            .off('mouseleave', onMenuInnerMouseLeave)
            .removeClass(active);

        $menu.addClass(active);
        if ($blurNotMenu) {
            $header.addClass(active);
            $notMenu.addClass('blur');
        }

        const scrollBarWidth = innerWidth - document.documentElement.offsetWidth;

        $html.addClass('menu-open');

        if (scrollBarWidth) {
            $html.css({ '--scrollbar-width': `${scrollBarWidth}px` });
        }

        NLMK.disableScroll($menu[0]);

        isOpen = true;
    } else {
        closeMenu();
    }
}

function closeMenu() {
    $html.removeClass('menu-open');
    $menu.removeClass(active);
    $menuInners.removeClass(active);
    $navLinks.removeClass(active);
    $menuNavItems.removeClass(active);
    $menuRightInners.removeClass(active);
    $notMenu.removeClass('blur');
    $header.removeClass(active);

    $menuRightInnersDefaultActive.addClass('active');

    NLMK.enableScroll($menu[0]);

    isOpen = false;
}



// WEBPACK FOOTER //
// ./js/main/module/head/menu.js